import { gql } from '@apollo/client'

export const TENANT_CONTACTS_FRAGMENT = gql`
	fragment tenantContactsFragment on TenantContact {
		id
		name
		contactType
		email
		department
		fullAddress
		name
		phone
		title
	}
`

export const TENANT_INFO_FRAGMENT = gql`
	fragment tenantInfoFragment on TenantInfo {
		id
		name
		contactType
		email
		department
		fullAddress
		name
		phone
		title
	}
`
